export class ViewUpdateTpr {
    tprToolId = null;
    programNameYear = null;
    toolId = null;
    programId = null;
    programName = null;
    fullProgramName = null;
    cfeFirstLastName = null;
    modelYear = null;
    toolName = null;
    stablePartCode1 = null;
    stablePartCode2 = null;
    partNumber = null;
    partNumber2 = null;
    typeId = null;
    typeName = null;
    typeDept = null;
    engineerId = null;
    lastFirstName = null;
    cfe = null;
    cfeId = null;
    cfeLastFirstName = null;
    span = null;
    prDate = null;
    allocDate = null;
    fixtLocId = null;
    fixtLoc = null;
    designSourceId = null;
    designSource = null;
    userSourceId = null;
    userSource = null;
    constSourceId = null;
    constSource = null;
    firstUserSourceId = null;
    firstUserSource = null;
    buildSchedFinish = null;
    fixtureRequired = null;
    rStudyScheduleDate = null;
    na1 = null;
    rStudyActualDate = null;
    rRScheduleDate = null;
    na2 = null;
    rRActualDate = null;
    fixtureRequired2 = null;
    gaDesign = null;
    gaBuild = null;
    risk1 = null;
    risk2 = null;
    risk1Calc = null;
    risk2Calc = null;
    r1 = null;
    r2 = null;
    arrvTryout = null;
    arrvUserSrc = null;
    progMake = null;
    pkReqDate = null;
    gdAndT = null;
    designOnly = null;
    pkWeld = null;
    pkProdInfo = null;
    pkCriteria = null;
    datumMatrix = null;
    pkApprDate = null;
    designSchedStart = null;
    designActualStart = null;
    modelPerc = null;
    mathPerc = null;
    detail1Perc = null;
    checkedPerc = null;
    opsPerc = null;
    designSchedFinish = null;
    designActualFinish = null;
    designForecast = null;
    designWeeksAdj = null;
    buildWeeksAdj = null;
    rStudyWeeksAdj = null;
    rRStudyWeeksAdj = null;
    fabricationPerc = null;
    buildSchedStart = null;
    buildActualStart = null;
    ncPrgmPerc = null;
    machiningPerc = null;
    assemblyPerc = null;
    certPerc = null;
    finalAsmPerc = null;
    processDate = null;
    ppecDate = null;
    buildActualFinish = null;
    buildForecast = null;
    eRdbk = null;
    eRdbkCert = null;
    eRdbkCertNA = null;
    eRdbkOp = null;
    eRdbkCfs = null;
    eRdbkTs = null;
    jTSentSched = null;
    jTSentAct = null;
    avoSched = null;
    aVoAct = null;
    mrRevSched = null;
    mRRevAct = null;
    mathJesRevSched = null;
    mathJesRevAct = null;
    todaysDate = null;
    lastUpdated = null;
    tprAction = null;
    tprActionDate = null;
    reSourced = null;
    tprActive = null;
    approxWeight = null;
    approxLength = null;
    approxWidth = null;
    approxHeight = null;
    style = null;
    toolNo = null;
    gdAndTSel = null;
    pkWeldSel = null;
    pkProdInfoSel = null;
    pkCriteriaSel = null;
    datumMatrixSel = null;
    productChgLvl = null;
    gdtChgLvl = null;
    tmacsCfDesRqd = null;
    tmacsCfRqd = null;
    chgCfReq = null;
    chgCfDesReq = null;
    dsRep = null;
    revisionTpr = null;
    eRdbkBo = null;
    eMail = null;
    quotePrice = null;
    quoteTiming = null;
    overrideTm = null;
    spanId = null;
    eRdbkBob = null;
    qabmse = null;
    qabdie = null;
    fmtPrDate = null;
    fmtAllocDate = null;
    fmtBuildSchedFinish = null;
    fmtFixtureRequired = null;
    fmtRStudyScheduleDate = null;
    fmtRStudyActualDate = null;
    fmtRScheduleDate = null;
    fmtRrActualDate = null;
    fmtFixtureRequired2 = null;
    fmtArrvTryout = null;
    fmtArrvUserSrc = null;
    fmtPkReqDate = null;
    fmtPkApprDate = null;
    fmtProcessDate = null;
    fmtDesignSchedStart = null;
    fmtModelPerc = null;
    fmtMathPerc = null;
    fmtDetail1Perc = null;
    fmtCheckedPerc = null;
    fmtOpsPerc = null;
    fmtDesignActualStart = null;
    fmtDesignSchedFinish = null;
    fmtTmacsCFDesRqd = null;
    fmtTmacsCFRqd = null;
    fmtChgCFReq = null;
    fmtChgCFDesReq = null;
    fmtDesignActualFinish = null;
    fmtDesignForecast = null;
    fmtFabricationPerc = null;
    fmtNcPrgmPerc = null;
    fmtMachiningPerc = null;
    fmtAssemblyPerc = null;
    fmtCertPerc = null;
    fmtFinalAsmPerc = null;
    fmtBuildSchedStart = null;
    fmtBuildActualStart = null;
    fmtPpecDate = null;
    fmtBuildActualFinish = null;
    fmtBuildForecast = null;
    fmtJtSentSched = null;
    fmtJtSentAct = null;
    fmtAvoSched = null;
    fmtAvoAct = null;
    fmtMrRevSched = null;
    fmtMrRevAct = null;
    fmtMathJesRevSched = null;
    fmtMathJesRevAct = null;
    fmtApproxLength = null;
    fmtApproxWidth = null;
    fmtApproxHeight = null;
}